/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISilo0612Like, ISilo0612LikeInterface } from "../ISilo0612Like";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetStorage",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ISilo0612Like.AssetStorage",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ISilo0612Like__factory {
  static readonly abi = _abi;
  static createInterface(): ISilo0612LikeInterface {
    return new utils.Interface(_abi) as ISilo0612LikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISilo0612Like {
    return new Contract(address, _abi, signerOrProvider) as ISilo0612Like;
  }
}
